import React from "react";
import { faMoon, faSunAlt } from "@fortawesome/pro-regular-svg-icons";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@singlestore/fusion/components/select";
import { ThemePreference, useTheme } from "@singlestore/fusion/theme-context";

import { FaIcon } from "components/FaIcon/FaIcon";

import "./ThemeSelect.scss";

const selectValueLabelDict: { [key in ThemePreference]: string } = {
    light: "Light",
    dark: "Dark",
    system: "Mirror system",
};

export function ThemeSelect() {
    const { themeConditional, themePreference, setThemePreference } =
        useTheme();

    return (
        <Select
            value={themePreference}
            onValueChange={(value) =>
                setThemePreference(value as ThemePreference)
            }
        >
            <SelectTrigger
                aria-label={`${selectValueLabelDict[themePreference]}, Switch theme`}
                className="theme-select-trigger"
            >
                <SelectValue>
                    {themeConditional({
                        light: <FaIcon role="presentation" icon={faSunAlt} />,
                        dark: <FaIcon role="presentation" icon={faMoon} />,
                    })}
                </SelectValue>
            </SelectTrigger>
            <SelectContent align="end">
                <SelectItem value="system">System</SelectItem>
                <SelectItem value="light">Light</SelectItem>
                <SelectItem value="dark">Dark</SelectItem>
            </SelectContent>
        </Select>
    );
}
